import PAGES from "../../../../../../constants/pages";

export const INTERNAL_TM_HIDDEN_LINKS: readonly string[] = [
    PAGES.RETAILER.SALES_SUPPORT.COMMISSION_BULLETIN.URL,
    PAGES.RETAILER.SALES_SUPPORT.ORDER_SIM.URL,
];

type LinkNode = { link: string; links?: readonly LinkNode[] };

export const filterRetailerLinks = <T extends LinkNode>(link: T, hiddenLinks: readonly string[]): T => ({
    ...link,
    links: link.links
        ?.filter((child) => !hiddenLinks.includes(child.link))
        .map((child) => filterRetailerLinks(child, hiddenLinks)),
});
